import Header from "./../../../Headers/HeaderForAreLoggedIn/index.vue"
import LayoutMain from './../../../../layouts/LayoutMain.vue';
import Footer from "./../../../Footers/Footer/index.vue"
import ProgressHUD from "./../../../ProgressHUD/index.vue"
import QuestionsAnswers from "./../../Widget/QuestionsAnswers/index.vue"
import ReputationData from "./../../Widget/ReputationData/index.vue"
import { Auth, Api } from './../../../../services'

export default {
  name: "ProductDetails",
  props: [],
  components: {
    LayoutMain,
    Header,
    Footer,
    ProgressHUD,
    QuestionsAnswers,
    ReputationData,
  },
  mounted() {},
  data() {
    return {
      product: {
        _id: "",
        name: "",
        description: "",
        specs: "",
        price: "",
        type: "",
        details: {
          number: "",
          weight: "",
          shipping: "",
          manufacture: "",
          asin: "",
        },
        images: [""],
        available: 0,
        accept: true,
        draft: false,
      },
      reviews: [],
      comment: [],
      itemCount: 1,
      validationMessage: null,
      curentImage: '',
      isOwner: false
    }
  },
  methods: {
    minusItem() {
      if (this.itemCount > 1) {
        this.itemCount--
      }
    },
    plusItem() {
      if (this.itemCount < this.product.available) {
        this.itemCount++
      }
    },
    buyNow() {
      var itemForBasket = {
        product: this.product,
        quantity: this.itemCount,
      }

      this.$store.commit("addOrEditItem", itemForBasket)
      this.$router.push("/checkout")
    },
  },
  computed: {},
  beforeCreate() {},
  async created() {
    var response = await Api.getProductById(this.$route.params.id)
    console.log("draft*-*-*-*-*-*-*-*-*-*")
    console.log(response.data.results.product)

    if (response.data && !response.data.error) {
      this.product = response.data.results.product
      this.reviews = response.data.results.opinion
      this.comment = response.data.results.comment
      this.curentImage = this.product.images[0];
      const userInfo = Auth.getUserData()
      this.isOwner = (userInfo.id === this.product.user[0]['_id']) ? true : false
    } else {
      this.validationMessage = "Something went wrong."
      console.error("Something went wrong.")
    }

    this.$refs.progress.hide()
  },
  mounted() {
    $(".modal").modal()
    $("select").material_select()
  },
}



// WEBPACK FOOTER //
// ./src/components/Marketplace/Product/Details/ProductDetails.component.js